<ng-container *ngIf="resourceUrl">
    <iframe style="width: 100%;min-height: 303px;position: relative;" [src]="resourceUrl | safe:'resourceUrl'"
            frameborder="0" allowfullscreen (load)="onLoadIFrame()">
    </iframe>
</ng-container>